import React from 'react';
import { getFeaturedQuestions } from './predefinedQuestions';

/**
 * ConversationHistory component displays the chat history between user and AURA.
 */
export default function ConversationHistory({ messages, isLoading, onQuestionClick }) {
  if (!messages || messages.length === 0) {
    const featuredQuestions = getFeaturedQuestions();
    
    return (
      <div className="conversation-history p-4 text-center text-gray-500 text-sm">
        <p>No conversation yet. Ask AURA anything about the market!</p>
        <div className="mt-3 space-y-2">
          <p className="text-xs font-semibold text-gray-400 mb-2">Try asking:</p>
          <div className="flex flex-wrap gap-2 justify-center">
            {featuredQuestions.slice(0, 3).map((question, index) => (
              <button
                key={index}
                onClick={() => onQuestionClick && onQuestionClick(question)}
                className="text-xs px-3 py-1.5 bg-blue-50 hover:bg-blue-100 text-blue-600 rounded-full transition-colors cursor-pointer border border-blue-200"
                title={`Click to ask: ${question}`}
              >
                {question}
              </button>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="conversation-history space-y-3 p-2">
      {messages.map((message, index) => (
        <div
          key={index}
          className={`flex ${message.type === 'user' ? 'justify-end' : 'justify-start'}`}
        >
          <div
            className={`
              max-w-[80%] rounded-lg p-3
              ${message.type === 'user'
                ? 'bg-blue-500 text-white'
                : 'bg-gray-100 text-gray-800'
              }
            `}
          >
            {message.type === 'user' ? (
              // For user messages, show command text directly without "You" label
              <>
                <div className="text-sm leading-relaxed whitespace-pre-wrap font-medium">
                  {message.text}
                </div>
                {message.timestamp && (
                  <div className="text-xs mt-1 opacity-60">
                    {new Date(message.timestamp).toLocaleTimeString()}
                  </div>
                )}
              </>
            ) : (
              // For AURA messages, show "AURA" label
              <>
                <div className="text-xs font-semibold mb-1 opacity-75">
                  AURA
                </div>
                <div className="text-sm leading-relaxed whitespace-pre-wrap">
                  {message.text}
                </div>
                {message.timestamp && (
                  <div className="text-xs mt-1 opacity-60">
                    {new Date(message.timestamp).toLocaleTimeString()}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      ))}
      
      {isLoading && (
        <div className="flex justify-start">
          <div className="bg-gray-100 rounded-lg p-3">
            <div className="flex items-center gap-2 text-sm text-gray-600">
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500"></div>
              <span>AURA is thinking...</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

